import React from 'react';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {TagSmall} from '@wix/wix-ui-icons-common';
import {useEnvironment} from '@wix/yoshi-flow-editor';
import {CartItemDataHook} from '../../CartItem';
import {classes} from '../../CartItem.st.css';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';

export const ItemDiscounts = ({lineItem}: {lineItem: LineItemModel}) => {
  const {isRTL} = useEnvironment();

  return (
    <div data-hook={CartItemDataHook.Discounts} className={classes.discountsRoot}>
      {lineItem.discounts?.map(({name, amountOff}, index: number) => (
        <div key={`name-${index}`} className={classes.discountTag}>
          <TagSmall aria-hidden data-hook={CartItemDataHook.DiscountIcon} className={classes.discountIcon} />
          <Text className={classes.discountNameText}>
            <span data-hook={CartItemDataHook.DiscountName}>{name}</span>
            {amountOff && amountOff.convertedAmount > 0 && (
              <>
                {' '}
                <span data-hook={CartItemDataHook.DiscountAmountOff}>
                  {isRTL ? `(${amountOff.formattedConvertedAmount}-)` : `(-${amountOff.formattedConvertedAmount})`}
                </span>
              </>
            )}
          </Text>
        </div>
      ))}
    </div>
  );
};
